module.exports = __webpack_public_path__ + "static/media/educacao_sp.5d2214e1.png";